import { useState } from "react";
import { Pagination } from "./Pagination";

const PaginationRow = ({
  totalRecords,
  uniqueKey,
  currentpage,
  setCurrentPage,
  totalPage,
  pagesize,
  setPageSize,
}) => {
  const [sizeDropdown, setSizeDropdown] = useState(false);

  const handlePageSize = (size) => {
    setSizeDropdown(false);
    setPageSize(size);
  };

  return (
    <div className="flex-container mt-2">
      {/* <p className="info">
        Total Results: <b>{totalRecords}</b>
      </p> */}

      <Pagination
        uniqueKey={uniqueKey}
        page={currentpage}
        isLoading={false}
        totalPage={totalPage}
        onPageChange={(page) => setCurrentPage(page)}
      />

      <div class="hs-dropdown">
        <p>Per Page</p>
        <button
          id="hs-pagination-dropdown"
          type="button"
          onClick={() => setSizeDropdown(!sizeDropdown)}
          className="dropdown-button"
        >
          {pagesize}
          <svg
            className={`dropdown-icon ${sizeDropdown ? "rotate-180" : ""}`}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="m6 9 6 6 6-6" />
          </svg>
        </button>
        {sizeDropdown && (
          <div
            class={`dropdown-menu block`}
            aria-labelledby="hs-pagination-dropdown"
          >
            {[6, 10, 25, 100].map((size, i) => (
              <button
                key={i}
                type="button"
                onClick={() => handlePageSize(size)}
                class="w-full flex items-center gap-x-2 py-2 px-3 rounded-lg text-sm border-none text-gray-800 hover:bg-gray-100 focus:outline-none hover:border-none disabled:opacity-50 disabled:pointer-events-none"
              >
                {size}
                {pagesize === size && (
                  <svg
                    class="check-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                )}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PaginationRow;
